const OS_API_URLS = {
    getAllContracts: '/evolveGetAllContracts',
    getContracts: '/evolveGetContracts',
    updateWorkflow: '/evolveUpdateWorkflow',
    createWorkflow: '/evolveCreateWorkflow',
    getContractDetails: '/evolveGetContractDetails',
    aiDataAnalyst: '/evolveAiDataAnalyst',
    getContractClaims: '/evolveGetContractClaims',
    getClaimsKPI: '/evolveGetClaimsKPI',
    getClaimLines: '/evolveGetClaimLines',
    getContractFunds: '/evolveGetContractFunds',
    getContractProviders: '/evolveGetContractProviders',
    getContractQualityMeasures: '/evolveGetContractQualityMeasures',
    getQualityMeasuresKPI: '/evolveGetQualityMeasuresKPI',
    getCounterpartyDetails: '/evolveGetCounterpartyDetails',
    getProvidersKPI: '/evolveGetProvidersKPI',
    getProviderDetails: '/evolveGetProviderDetails',
    getOverviewData: '/evolveGetOverviewData',
    getMembers: '/evolveGetMembers',
    getMembersKPI: '/evolveGetMembersKPI',
    getAllCounterparties: '/evolveGetAllCounterparties',
    getContractInfo: '/evolveGetContractInfo',
    getContract: '/evolveGetContract',
    getSignedURLs: '/evolveGetSignedURLs',
    readUploadedFiles: '/evolveReadUploadedFiles',
    setContractFile: '/evolveSetContractFile',
    getAllFiles: '/evolveGetAllFiles',
    getContractFiles: '/evolveGetContractFiles',
    updateContract: '/evolveUpdateContract',
    getProgramDetails: '/evolveGetProgramDetails',
    getTCOCSummary: '/evolveGetTCOCSummary',
    deleteContractFiles: '/evolveDeleteContractFiles',
    deleteContract: '/evolveDeleteContract',
    getMemberDetails: '/evolveGetMemberDetails',
    getMemberDetailsWithPermission: '/evolveGetMemberDetailsWithPermission',
    getAttributedMembers: '/evolveGetAttributedMembers',
    getAttributedMembersKPI: '/evolveGetAttributedMembersKPI',
    getWorkflow: '/evolveGetWorkflow',
    getAllWorkflows: '/evolveGetAllWorkflows',
    createNewContract: '/evolveCreateNewContract',
    deleteWorkflow: '/evolveDeleteWorkflow',
    getWorkflowEditorOptions: '/evolveGetWorkflowEditorOptions',
    getContractEditorOptions: '/evolveGetContractEditorOptions',
    createNewContractFile: '/evolveCreateNewContractFile',
    getMembersFilter: '/evolveGetMembersFilter',
    getICD10CodeFilter: '/evolveGetICD10CodeFilter',
    getPatientsFilter: '/evolveGetPatientsFilter',
    getClaimStatusFilter: '/evolveGetClaimStatusFilter',
    getProvidersFilter: '/evolveGetProvidersFilter',
    getQualityMeasuresFilter: '/evolveGetQualityMeasuresFilter',
    getFundsFilter: '/evolveGetFundsFilter',
    getContractsFilter: '/evolveGetContractsFilter',
    getContractType: '/evolveGetContractType',
    getLineOfBusiness: '/evolveGetLineOfBusiness',
    getFundingStrategies: '/evolveGetFundingStrategies',
    getContractStatuses: '/evolveGetContractStatuses',
    getProviderKPI: '/evolveGetProviderKPI',
    getTaskStatuses: '/evolveGetTaskStatuses',
    getArrangementTypes: '/evolveGetArrangementTypes',
    getFeeCostBases: '/evolveGetFeeCostBases',
    getContingencyCostBases: '/evolveGetContingencyCostBases',
    getBusinessSegments: '/evolveGetBusinessSegments',
    getSharedCostBases: '/evolveGetSharedCostBases',
    checkAuthorization: '/evolveCheckAuthorization',
    getCognitoRedirectURL: '/evolveGetCognitoRedirectURL',
    getCognitoLogoutURL: '/evolveGetCognitoLogoutURL',
    getGroup: '/evolveGetGroup',
    createGroup: '/evolveCreateGroup',
    getAllUserRoles: '/evolveGetAllUserRoles',
    updateGroup: '/evolveUpdateGroup',
    deleteGroup: '/evolveDeleteGroup',
    getUserByRole: '/evolveGetUserByRole',
    getUser: '/evolveGetUser',
    getAllUsers: '/evolveGetAllUsers',
    getLoginUserData: '/evolveGetLoginUserData',
    createTooltip: '/evolveCreateTooltip',
    getTooltip: '/evolveGetTooltip',
    getTooltipByKey: '/evolveGetTooltipByKey',
    getAllTooltips: '/evolveGetAllTooltips',
    updateTooltip: '/evolveUpdateTooltip',
    deleteTooltip: '/evolveDeleteTooltip',
    createContractSchema: '/evolveCreateContractSchema',
    getContractSchema: '/evolveGetContractSchema',
    getAllContractSchemas: '/evolveGetAllContractSchemas',
    getContractSchemaVersions: '/evolveGetContractSchemaVersions',
    addContractSchemaVersion: '/evolveAddContractSchemaVersion',
    updateContractSchema: '/evolveUpdateContractSchema',
    deleteContractSchema: '/evolveDeleteContractSchema',
    cloneContractSchema: '/evolveCloneContractSchema',
    createNewContractBySchema: '/evolveCreateNewContractBySchema',
    getSchemaNameByUUID: '/evolveGetSchemaNameByUUID',
    createPDF: '/evolveCreatePDF',
    generatePreview: '/evolveGeneratePreview',
    getContractReports: '/evolveGetContractReports',
    getReports: '/evolveGetReports',
    createReport: '/evolveCreateReport',
    updateReport: '/evolveUpdateReport',
    deleteReport: '/evolveDeleteReport',
    generateReportPlaceholders: '/evolveGenerateReportPlaceholders',
    getPdfPresignedUrl: '/evolveGetPdfPresignedUrl',
    getUploadSignedURL: '/evolveGetUploadSignedURL',
    readMediaItem: '/evolveReadMediaItem',
    createMedia: '/evolveCreateMedia',
    updateMedia: '/evolveUpdateMedia',
    getAllMedia: '/evolveGetAllMedia',
    deleteMediaFile: '/evolveDeleteMediaFile',
    getApprovals: '/evolveGetApprovals',
    sendApprovalToReview: '/evolveSendApprovalToReview',
    sendSettlementApprovalToReview: '/evolveSendSettlementApprovalToReview',
    revertApprovalToDraft: '/evolveRevertApprovalToDraft',
    approveRequest: '/evolveApproveRequest',
    rejectApproval: '/evolveRejectApproval',
    archiveApproval: '/evolveArchiveApproval',
    getContractVersions: '/evolveGetContractVersions',
    addContractVersion: '/evolveAddContractVersion',
    getEntityApproval: '/evolveGetEntityApproval',
    getUserApprovals: '/evolveGetUserApprovals',
    getApprovalGroups: '/evolveGetApprovalGroups',
    assignUsersToRole: '/evolveAssignUsersToRole',
    removeUsersFromRole: '/evolveRemoveUsersFromRole',
    getDynamoUser: '/evolveGetDynamoUser',
    getContractsStatusAnalytics: '/evolveGetContractsStatusAnalytics',
    getContractSchemaByKey: '/evolveGetContractSchemaByKey',
    getSystemConfigsCollection: '/evolveGetSystemConfigsCollection',
    getReportsByTemplate: '/evolveGetReportsByTemplate',
    cloneReport: '/evolveCloneReport',
    getEntitiesAudit: '/evolveGetEntitiesAudit',
    getPendingContracts: '/evolveGetPendingContracts',
    getContractSchemas: '/evolveGetContractSchemas',
    getUserInfo: '/evolveGetUserInfo',
    getHeadContractNames: '/evolveGetHeadContractNames',
    getPendingContractSchemas: '/evolveGetPendingContractSchemas',
    getContractExpensesGroupedByProvider: '/evolveGetContractExpensesGroupedByProvider',
    getContractTotalExpenseByPeriod: '/evolveGetContractTotalExpenseByPeriod',
    deleteSingleFile: '/evolveDeleteSingleFile',
    getContractCostUtilizationByPeriod: '/evolveGetContractCostUtilizationByPeriod',
    getContractKpiByPeriod: '/evolveGetContractKpiByPeriod',
    getContractRevenueExpenseTrendByPeriod: '/evolveGetContractRevenueExpenseTrendByPeriod',
    getContractMarginExpenseByPeriod: '/evolveGetContractMarginExpenseByPeriod',
    getContractTotalExpensePMPMByPeriod: '/evolveGetContractTotalExpensePMPMByPeriod',
    getContractExpensesPMPMGroupedByProvider: '/evolveGetContractExpensesPMPMGroupedByProvider',
    onDemandQuery: '/evolveOnDemandQuery',
    getContractCostUtilizationReport: '/evolveGetContractCostUtilizationReport'
}

export default OS_API_URLS
